import { useEffect, useState } from 'react';
import { ContactRepModalDetails } from '@mb/lib';
import { ModalPlacement } from '../components/ContactRepModalView/types';

const MINIMUM_TOP_OFFSET = 700;
const MINIMUM_RIGHT_OFFSET = 290;

export const useModalPlacement = (modalDetails?: ContactRepModalDetails) => {
  if (!modalDetails) {
    return { modalPlacement: ModalPlacement.Bottom, modalXOffset: 0 };
  }

  const { portalTarget } = modalDetails;
  const [modalPlacement, setModalPlacement] = useState(
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    modalDetails.modalPlacement as ModalPlacement,
  );
  const [modalXOffset, setModalXOffset] = useState(0);
  const top = portalTarget.getBoundingClientRect().top;
  const right =
    window.innerWidth -
    portalTarget.getBoundingClientRect().right +
    portalTarget.clientWidth;

  useEffect(() => {
    if (top < MINIMUM_TOP_OFFSET) {
      setModalPlacement(ModalPlacement.Bottom);
    } else {
      // TODO: refactor without type assertion, or add comment
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      setModalPlacement(modalDetails.modalPlacement as ModalPlacement);
    }
  }, [top]);

  useEffect(() => {
    if (right < MINIMUM_RIGHT_OFFSET) {
      setModalXOffset(right - MINIMUM_RIGHT_OFFSET);
    }
  }, [right]);

  return { modalPlacement, modalXOffset };
};
